import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    clearPersonalAccidentFormData,
    selectPersonalAccidentForm,
    setPersonalAccidentFormData
} from "../redux/features/personalAccidentFormSlice";

const usePersonalAccidentForm = (formName, setFormData) => {
    const dispatch = useDispatch();
    const personalAccidentFormData = useSelector(selectPersonalAccidentForm);
    const redux_form_data = personalAccidentFormData?.[formName];
    const isInitialized = useRef(false);

    useEffect(() => {
        // Only initialize once per mount
        if (isInitialized.current) return;

        if (redux_form_data) {
            setFormData(redux_form_data);
            isInitialized.current = true;
        }
    }, [redux_form_data, setFormData]);

    const savePersonalAccidentDataInRedux = async (formData) => {
        return new Promise((resolve, reject) => {
            try {
                dispatch(setPersonalAccidentFormData({ form_name: formName, data: formData }));
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    };

    const removePersonalAccidentFormData = () => {
        dispatch(clearPersonalAccidentFormData({ form_name: formName }));
    };

    return { 
        savePersonalAccidentDataInRedux, 
        removePersonalAccidentFormData, 
        redux_form_data 
    };
};

export default usePersonalAccidentForm;